import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useLayoutStyles = makeStyles(() => {
  return createStyles({
    container: {
      overflow: 'hidden',
      display: 'grid',
      gap: '1px',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gridAutoFlow: 'row',
      gridTemplateAreas: `". ."
          ". ."`,
      height: '16px',
      width: '16px',
      backgroundColor: 'transparent',
    },
  });
});

export default useLayoutStyles;
